import Logo from "../../assets/logo.svg";
import { LanguageSelector } from "../language-detector/language-detector";
import styles from "./header.module.scss";

export function Header() {
  return (
    <div className={styles.header}>
      <img src={Logo} alt="Logo" />
      <LanguageSelector />
    </div>
  );
}
